import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Snackbar } from '@material-ui/core';
import CustomCard from '../views/CardItem';
import EmployeeData from '../models/EmployeeModel';
import Header from '../views/Header';
import SearchAppBar from '../views/FilterEmployee';
import EmployeeTable from '../views/EmployeeTable';
import InformationEmployeeDialog from '../views/Modal/ModalInformationEmployee';
import ViewRegister from '../views/RegisterEmployee/ViewRegister';
import ModalConfigEmployee from '../views/Modal/ModalConfigEmployee';
import { Alert } from '@mui/material';
import {CircularProgress,Backdrop} from '@material-ui/core';
// import Backdrop from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        backgroundColor: '#f3f7fa',
        marginLeft: -15
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

function EmployeeViewModel() {
    const {
        employeeNewData,
        departmentList,
        dataCard,
        companyName,
        handlechangeFilter,
        selectedDepartment,
        employeeFilterSelected,
        schedule,
        scheduleSelected,
        isFilter,
        status,
        selectedEmployee,
        handleSelectedEmployee,
        tableState,
        modalInformation,
        handleSelectedCard,
        viewEmployeeRegistration,
        handleOpenModalConfig,
        typeModalConfig,
        openModalConfig,
        handleCloseModalConfig,
        messageErrorConfig,
        openMessageErrorConfig,
        setOpenMessageErrorConfig,
        loadingEmployee
    } = EmployeeData()

    const classes = useStyles();


    return (
        <div className={classes.root}>
            <main className={classes.content}>
                <Snackbar
                    open={openMessageErrorConfig}
                    autoHideDuration={3000}
                    onClose={() => setOpenMessageErrorConfig(false)}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} // Adicionei esta linha
                >
                    <Alert onClose={() => setOpenMessageErrorConfig(false)}
                        severity="error"
                        sx={{ width: '100%', backgroundColor: 'white', color: 'red' }}
                    >
                        {messageErrorConfig}
                    </Alert>
                </Snackbar>
                <Backdrop className={classes.backdrop} open={loadingEmployee}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                {
                    viewEmployeeRegistration.viewRegistration ?
                        <ViewRegister viewEmployeeRegistration={viewEmployeeRegistration} />
                        :
                        <>
                            <Header companyName={companyName} />
                            <Grid>
                                <CustomCard
                                    employeeNewData={employeeNewData}
                                    dataCard={dataCard}
                                    handlechangeFilter={handlechangeFilter}
                                    handleSelectedCard={handleSelectedCard}
                                    viewEmployeeRegistration={viewEmployeeRegistration}
                                />
                            </Grid>
                            <SearchAppBar
                                employeeNewData={employeeNewData}
                                departmentList={departmentList}
                                handlechangeFilter={handlechangeFilter}
                                selectedDepartment={selectedDepartment}
                                schedule={schedule}
                                scheduleSelected={scheduleSelected}
                                status={status}
                                selectedEmployee={selectedEmployee}
                                handleSelectedEmployee={handleSelectedEmployee}
                                handleSelectedCard={handleSelectedCard}
                                tableState={tableState}
                                handleOpenModalConfig={handleOpenModalConfig}
                            />
                            <EmployeeTable
                                tableState={tableState}
                                viewEmployeeRegistration={viewEmployeeRegistration}
                            />
                            <InformationEmployeeDialog
                                modalInformation={modalInformation}
                            />
                        </>
                }
                <ModalConfigEmployee
                    open={openModalConfig}
                    viewEmployeeRegistration={viewEmployeeRegistration}
                    typeModalConfig={typeModalConfig}
                    onClose={handleCloseModalConfig}
                />

            </main>
        </div>
    );
}

export default EmployeeViewModel;
